import './Dashboard.scss'
import React, { useRef } from 'react';
import {
    LegendModule,
    CategoryAxisModule,
    LineSeriesModule,
    ModuleRegistry,
    NumberAxisModule,
} from 'ag-charts-enterprise';
import { DatePicker, Button } from 'antd';
import dayjs from 'dayjs';
import { DashboardLogic } from './Dashboard';
import AISummary from '../../components/AISummary/AISummary.jsx';
import MapPage from '../Maps';
import EventsByTypeChart from '../../components/EventsByTypeChart/EventsByTypeChart.jsx';
import EventsByLocationChart from '../../components/EventsByLocationChart/EventsByLocationChart.jsx';
import EventsBySiteChart from '../../components/EventsBySiteChart/EventsBySiteChart.jsx';
import DetectionEventsChart from '../../components/DetectionEventsChart/DetectionEventsChart.jsx';
import EndpointUsageChart from '../../components/EndpointUsageChart/EndpointUsageChart.jsx';
import OVMSUsageChart from '../../components/OVMSUsageChart/OVMSUsageChart.jsx';
import SiteModelAccuracyChart from '../../components/SiteModelAccuracyChart/SiteModelAccuracyChart.jsx';
import { useIsAdmin } from '../../store/index.js';

ModuleRegistry.registerModules([
    CategoryAxisModule,
    LegendModule,
    LineSeriesModule,
    NumberAxisModule,
]);

const { RangePicker } = DatePicker;

function Dashboard() {
    const {
        setFilterDates,
        startAndEndUnixDatesParams,
        formatDateRange,
        summaryLoading,
        setSummaryLoading,
    } = DashboardLogic();

    const siteEventsChart = useRef(null);
    const aiSummaryRef = useRef(null);
    const isAdmin = useIsAdmin();

    return (
        <div className='dashboard container-wrapper'>
            <div className='dashboard-row'>
                <RangePicker
                    onChange={(value, timeString) => {
                        setFilterDates({
                            start_date: dayjs(timeString[0]).startOf('day'),
                            end_date: dayjs(timeString[1]).endOf('day')
                        })
                    }}
                    disabledDate={(current) => current && current < dayjs().subtract(1, 'years').startOf('day')}
                    format={'MM/DD/YYYY'}
                    className='rangeStyle'
                    defaultValue={[dayjs().subtract(30, 'day'), dayjs()]}
                />
                <Button
                    type="primary"
                    onClick={() => aiSummaryRef.current?.triggerFetch()}
                    loading={summaryLoading}
                    style={{ marginBottom: '16px' }}
                >
                    Generate Summary
                </Button>
            </div>

            <div className='ai-overview dashboard-row'>
                <AISummary
                    ref={aiSummaryRef}
                    startAndEndUnixDatesParams={startAndEndUnixDatesParams}
                    onLoadingChange={setSummaryLoading}
                />
            </div>

            {/* Wrap both charts in a flex container */}
            <div className='dashboard-row'>
                <div className='dashboard-row-item'>
                    <EventsByLocationChart startAndEndUnixDatesParams={startAndEndUnixDatesParams} formatDateRange={formatDateRange} />
                </div>
                <div className='dashboard-row-item'>
                    <EventsByTypeChart startAndEndUnixDatesParams={startAndEndUnixDatesParams} formatDateRange={formatDateRange} />
                </div>
            </div>


            <div className='lineCharts dashboard-row'>
                <div className='dashboard-row-item' ref={siteEventsChart}>
                    <EventsBySiteChart startAndEndUnixDatesParams={startAndEndUnixDatesParams} formatDateRange={formatDateRange} />
                </div>
                <div className='dashboard-row-item'>
                    <DetectionEventsChart startAndEndUnixDatesParams={startAndEndUnixDatesParams} formatDateRange={formatDateRange} />
                </div>
            </div>
            {isAdmin && (
            <div className='dashboard-row'>
                <div className='dashboard-row-item'>
                    <EndpointUsageChart startAndEndUnixDatesParams={startAndEndUnixDatesParams} />
                </div>
                <div className='dashboard-row-item'>
                    <OVMSUsageChart startAndEndUnixDatesParams={startAndEndUnixDatesParams} />
                </div>
            </div>
            )}

            <div className='dashboard-row'>
                <SiteModelAccuracyChart hideUnknowns={true} startAndEndUnixDatesParams={startAndEndUnixDatesParams} />
            </div>

            {/* Left out until licensing is sorted out */}
            {/* <div>
                <h2>Deployment Map</h2>
                <MapPage isHalfScreen={true} />
            </div> */}
        </div>
    )

}

export default Dashboard